import React, { Dispatch, useEffect } from 'react';
import { Col, Row, Collapse, Form, Input } from 'antd';
import { Action } from 'typesafe-actions';
import { useDispatch, useSelector } from 'react-redux';
import FilterContainer from '../../../../components/FilterContainer';
import { ApplicationState } from '../../../../store';
import CollapseTitle from '../../../../components/TitleCollapseFilter';
import FilterBtn from '../../../../components/FilterBtn';
import ClearFilterBtn from '../../../../components/ClearFilterBtn';
import CollapseFilter from '../../../../components/CollapseFilter';
import TextFilter from '../../../../components/TextFilter';
import {
  loadRequest,
  filterBlackList,
  cleanBlackList,
} from '../../../../store/ducks/blackList/actions';

interface Props {
  tabeKey: string;
}

const Filter: React.FC<Props> = ({ tabeKey }) => {
  const { Panel } = Collapse;
  const dispatch = useDispatch<Dispatch<Action>>();
  const filter = useSelector((state: ApplicationState) => state.BlackList.filter);
  const typeRequest = tabeKey === '1' ? 'motorista' : 'veiculo';
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);

  useEffect(() => {
    if (inscricaoAtiva.length > 0) dispatch(loadRequest(typeRequest, filter));
    return;
  }, [dispatch, filter, tabeKey, typeRequest, inscricaoAtiva]);

  const onFilter = (values: any) => {
    const { cpf, placa } = values;
    const cpfCleaned = cpf?.replace(/[^\d]+/g, '');
    const filter = {
      cpf: cpfCleaned,
      placa,
    };
    filterBlackList(filter);
    localStorage.setItem(window.location.pathname + 'valuesFilter', JSON.stringify(filter));
    dispatch(loadRequest(typeRequest, filter));
  };

  const clearFilter = () => {
    dispatch(cleanBlackList());
    dispatch(loadRequest(typeRequest));
    localStorage.removeItem(window.location.pathname + `valuesFilter`);
  };

  const localStorageItensPersist: string = JSON.parse(
    localStorage.getItem(window.location.pathname + `valuesFilter`) || '{}'
  );

  return (
    <CollapseFilter>
      <Panel header={<CollapseTitle>Filtro</CollapseTitle>} key="1">
        <FilterContainer onFilter={onFilter} initialValues={localStorageItensPersist}>
          <Row gutter={24}>
            {tabeKey === '1' ? (
              <Col md={8} sm={24} xs={24}>
                <Form.Item name="cpf" label={<TextFilter>CPF</TextFilter>}>
                  <Input placeholder="Digite o CPF do motorista" />
                </Form.Item>
              </Col>
            ) : (
              <Col md={8} sm={24} xs={24}>
                <Form.Item name="placa" label={<TextFilter>Placa</TextFilter>}>
                  <Input placeholder="Digite a placa do veículo" />
                </Form.Item>
              </Col>
            )}
          </Row>

          <Row gutter={24} justify="end">
            <Col md={6} sm={24} xs={24}>
              <ClearFilterBtn onClick={clearFilter}>Limpar filtros</ClearFilterBtn>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <FilterBtn>Filtrar</FilterBtn>
            </Col>
          </Row>
        </FilterContainer>
      </Panel>
    </CollapseFilter>
  );
};

export default Filter;
